import {
  Button,
  paletteHelper,
  spacingHelper,
  Text,
  typographyHelper,
} from '@property.com.au/ui-kit';
import { Fragment, FunctionComponent, useState } from 'react';
import styled from 'styled-components';
import {
  ApiButtonVariant,
  mapApiButtonVariantToButtonVariant,
} from '../../../../../app-kit/helpers/mapApiButtonVariantToButtonVariant';

export interface SuburbPageMarketInsightsDescriptionProps {
  paragraphs: string[];
  expansionToggle: {
    visible: boolean;
    text: string;
    buttonVariant: ApiButtonVariant;
  };
}

const DescriptionTextContainer = styled.div`
  margin-top: ${spacingHelper('medium')};
`;

const DescriptionText = styled(Text)`
  color: ${paletteHelper('textSecondary')};
  ${typographyHelper('body01')};
`;

const DescriptionTextHeightController = styled.div<{ $shouldLimitHeight: boolean }>`
  position: relative;
  height: ${({ $shouldLimitHeight }) => ($shouldLimitHeight ? '130px' : 'none')};
  overflow: hidden;
  &::after {
    display: ${({ $shouldLimitHeight }) => ($shouldLimitHeight ? 'block' : 'none')};
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 75px;
    background: linear-gradient(to bottom, transparent, ${paletteHelper('backgroundPrimary')} 100%);
    pointer-events: none;
  }
`;

const ShowMoreButton = styled(Button)`
  justify-content: center;
  ${typographyHelper('overline')};
  margin: ${spacingHelper('large auto extraSmall')};
  display: flex;
`;

export const SuburbPageMarketInsightsDescription: FunctionComponent<
  SuburbPageMarketInsightsDescriptionProps
> = ({ paragraphs, expansionToggle }) => {
  const isExpandable = expansionToggle.visible;
  const [isExpanded, setIsExpanded] = useState(false);
  const shouldLimitHeight = isExpandable && !isExpanded;

  return (
    <>
      <DescriptionTextHeightController $shouldLimitHeight={shouldLimitHeight}>
        <DescriptionTextContainer>
          {paragraphs.map((text, index) => (
            <Fragment key={text}>
              <DescriptionText as="p" variant="body01">
                {text}
              </DescriptionText>
              {index !== paragraphs.length - 1 && <br />}
            </Fragment>
          ))}
        </DescriptionTextContainer>
      </DescriptionTextHeightController>

      {isExpandable && !isExpanded && (
        <ShowMoreButton
          variant={mapApiButtonVariantToButtonVariant(expansionToggle.buttonVariant)}
          onClick={() => setIsExpanded(true)}
        >
          {expansionToggle.text}
        </ShowMoreButton>
      )}
    </>
  );
};
